var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWastermaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_57155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6452 9.29032C15.9743 9.29032 15.3275 9.38826 14.7097 9.55742V4.64516H15.4839V2.32258H14.6017L13.8275 0H9.39832L8.62413 2.32258H0V4.64516H0.774194V11.6129H0V15.4839H0.774194V21.6774H0V24H16.6452C20.7008 24 24 20.7008 24 16.6452C24 12.5895 20.7008 9.29032 16.6452 9.29032ZM9.95652 0.774194H13.2697L13.7857 2.32258H9.44052L9.95652 0.774194ZM0.774194 3.09677H14.7097V3.87097H13.1613V4.64516H13.9355V9.81406C12.9263 10.2159 12.0286 10.8345 11.2963 11.6129H1.54839V4.64516H12.3871V3.87097H0.774194V3.09677ZM0.774194 12.3871H10.6595C10.4822 12.6352 10.3157 12.8915 10.1702 13.1613H6.19355V13.9355H9.81406C9.71381 14.1871 9.62942 14.4457 9.55742 14.7097H0.774194V12.3871ZM11.2963 21.6774H1.54839V15.4839H9.39135C9.33058 15.8632 9.29032 16.2492 9.29032 16.6452C9.29032 18.5923 10.0564 20.3605 11.2963 21.6774ZM0.774194 23.2258V22.4516H12.1475C12.5303 22.7489 12.9426 23.0079 13.3804 23.2258H0.774194ZM16.6452 23.2258C13.0165 23.2258 10.0645 20.2738 10.0645 16.6452C10.0645 13.0165 13.0165 10.0645 16.6452 10.0645C20.2738 10.0645 23.2258 13.0165 23.2258 16.6452C23.2258 20.2738 20.2738 23.2258 16.6452 23.2258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6457 15.4839C16.0054 15.4839 15.4844 16.0049 15.4844 16.6452C15.4844 17.2854 16.0054 17.8065 16.6457 17.8065C17.2859 17.8065 17.807 17.2854 17.807 16.6452C17.807 16.0049 17.2859 15.4839 16.6457 15.4839ZM16.6457 17.0323C16.4324 17.0323 16.2586 16.8589 16.2586 16.6452C16.2586 16.4315 16.4324 16.2581 16.6457 16.2581C16.859 16.2581 17.0328 16.4315 17.0328 16.6452C17.0328 16.8589 16.859 17.0323 16.6457 17.0323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7353 18.3582L17.1024 18.8033L18.7843 21.196C17.4453 21.8281 15.8439 21.8281 14.5049 21.196L16.1869 18.8033L15.5536 18.3582L13.375 21.4569L13.7404 21.6686C14.6253 22.1811 15.6295 22.4517 16.6448 22.4517C17.6602 22.4517 18.6643 22.1811 19.5484 21.6686L19.9138 21.4569L17.7353 18.3582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6764 13.7419C21.1689 12.8628 20.4326 12.1289 19.5466 11.6187L19.1804 11.4077L17.5859 14.8436L18.2881 15.1695L19.5191 12.5164C20.1276 12.9387 20.637 13.4895 21.0059 14.1286C21.3752 14.7681 21.5978 15.4846 21.659 16.222L18.7457 15.9619L18.6768 16.733L22.4498 17.0698L22.4502 16.6471C22.4517 15.6259 22.1843 14.621 21.6764 13.7419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7749 12.5168L15.0058 15.17L15.708 14.8441L14.1136 11.4082L13.7474 11.6192C12.8613 12.1294 12.125 12.8633 11.6176 13.7424C11.1101 14.6215 10.8426 15.6264 10.8438 16.6483L10.8441 17.071L14.6172 16.7343L14.5483 15.9624L11.635 16.2225C11.6961 15.4851 11.9187 14.7686 12.2876 14.1291C12.6569 13.49 13.1663 12.9392 13.7749 12.5168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90096 5.41943H2.32031V6.19363H8.90096V5.41943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4539 5.41943H9.67969V6.19363H10.4539V5.41943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32107 13.1614H1.54688V13.9356H2.32107V13.1614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86794 13.1614H3.09375V13.9356H3.86794V13.1614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42263 13.1614H4.64844V13.9356H5.42263V13.1614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_57155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastermaster);
export default __webpack_public_path__ + "static/media/wastermaster.20a9d8f4324dfd3e0008bbe0f0563db8.svg";
export { ForwardRef as ReactComponent };